/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BeforeInputs */

const en_before = /** @type {(inputs: BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before`)
};

const fr_before = /** @type {(inputs: BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avant`)
};

const de_before = /** @type {(inputs: BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor`)
};

const it_before = /** @type {(inputs: BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima`)
};

const ru_before = /** @type {(inputs: BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`До`)
};

const es_before = /** @type {(inputs: BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes`)
};

const zh_cn2_before = /** @type {(inputs: BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前`)
};

const ja_before = /** @type {(inputs: BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前に`)
};

const hi_before = /** @type {(inputs: BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहले`)
};

const pt_pt2_before = /** @type {(inputs: BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes`)
};

/**
* | output |
* | --- |
* | "Before" |
*
* @param {BeforeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const before = /** @type {((inputs?: BeforeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BeforeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_before(inputs)
	if (locale === "de") return de_before(inputs)
	if (locale === "it") return it_before(inputs)
	if (locale === "ru") return ru_before(inputs)
	if (locale === "es") return es_before(inputs)
	if (locale === "zh-CN") return zh_cn2_before(inputs)
	if (locale === "ja") return ja_before(inputs)
	if (locale === "hi") return hi_before(inputs)
	if (locale === "pt-PT") return pt_pt2_before(inputs)
	return en_before(inputs)
});